import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

import * as utils from './utils'

/**
 * Just finds the edits that need to be discarded. The actual discarding happens
 * in the success reducer
 */
export const discardEdits = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.discard.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        foundEdits: utils.findEdits(action.data, plugin),
      })),
      // Immediately returns a success with the found edits. The reducer for
      // this success will take care of actually discarding the edits
      rxjs.map(({ action, foundEdits }) =>
        feature.actions.discard.success
          .from(action)
          .create({ request: action.data, response: foundEdits }),
      ),
    ),
)
